'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoFileZip = function GoFileZip(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm17.5 22.5v-2.5h-2.5v2.5h2.5z m0-5v-2.5h-2.5v2.5h2.5z m0-5v-2.5h-2.5v2.5h2.5z m-5 2.5h2.5v-2.5h-2.5v2.5z m15-12.5h-22.5v35h30v-27.5l-7.5-7.5z m5 32.5h-25v-30h7.5v2.5h2.5v-2.5h7.5l7.5 7.5v22.5z m-20-25h2.5v-2.5h-2.5v2.5z m0 10h2.5v-2.5h-2.5v2.5z m0 5l-2.5 2.5v5h10v-5l-2.5-2.5h-2.5v-2.5h-2.5v2.5z m5 2.5v2.5h-5v-2.5h5z' })
        )
    );
};

exports.default = GoFileZip;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/go/file-zip.js
// module id = 1917
// module chunks = 0